export const selectTriggerOrderQuote = (state) => state.triggerOrders.quote;

export const selectExecutedTriggerOrderQuote = (state) =>
  state.triggerOrders.executedQuote;

export const selectTargetPriceAgain = (state) =>
  state.triggerOrders.targetPriceAgain;
